import styled from '@emotion/styled';
import { Tooltip } from '@fluentui/react-components';
import { IconButton, IconButtonProps, Star16Px, Unstar16Px, grey } from '@galaxy-react/core';
import { t } from 'i18next';
import React from 'react';
import { useAddFavouriteReportMutation, useDeleteFavouriteReportMutation } from 'src/app/standaloneSlices/apiSlice';

type Props = {
  reportName: string;
  isFavourite?: boolean;
  starIcon?: JSX.Element;
  unstarIcon?: JSX.Element;
} & IconButtonProps;

export const IconButtonStyled = styled(IconButton)({
  '&.fui-Button': {
    minWidth: '40px',
    minHeight: '40px',
    flex: 1,

    padding: '0',
    '&:hover': {
      background: 'transparent',
    },
    '&[data-fui-focus-within]': {
      boxShadow: 'none',
      border: 'none',
      outline: 'none',
    },
    '&[disabled], &[aria-disabled=true]': {
      background: 'transparent',
    },
  },
  '&.fui-Button .fui-Button__icon': {
    width: '24px',
    height: '24px',
    color: grey[300],
  },
});

const FavsIconButton = (props: Props) => {
  const [addFavouriteTrigger] = useAddFavouriteReportMutation();
  const [deleteFavouriteTrigger] = useDeleteFavouriteReportMutation();

  const { isFavourite, reportName } = props;
  const starIcon = props.starIcon || <Star16Px />;
  const unstarIcon = props.unstarIcon || <Unstar16Px />;
  if (props.size === 'large') {
  }

  const toggleFavourite = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    isFavourite ? deleteFavouriteTrigger({ ReportName: reportName }) : addFavouriteTrigger({ ReportName: reportName });
  };
  return (
    <Tooltip content={isFavourite ? t('Remove from favourites') : t('Add to favourites')} relationship={'label'}>
      {props.size === 'large' ? (
        <IconButtonStyled
          appearance="transparent"
          size="large"
          onClick={toggleFavourite}
          icon={isFavourite ? unstarIcon : starIcon}
        />
      ) : (
        <IconButton
          size="small"
          appearance="transparent"
          icon={isFavourite ? unstarIcon : starIcon}
          onClick={toggleFavourite}
        />
      )}
    </Tooltip>
  );
};

export default FavsIconButton;
